import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ConfirmButton, type ConfirmButtonProps } from './ConfirmButton.tsx';

export interface ButtonDeleteConfirmProps extends ConfirmButtonProps {}

/**
 * Button per eliminare un elemento
 * con conferma tramite Popconfirm
 */
export function ButtonDeleteConfirm(props: ButtonDeleteConfirmProps) {
  const { t } = useTranslation();

  const confirmProps = {
    size: 'small',
    buttonType: 'primary',
    buttonIcon: (
      <DeleteOutlined
        aria-label={t(
          'button.button-delete-confirm.icon-aria',
          'Elimina elemento',
        )}
      />
    ),
    buttonDanger: true,
    popconfirmButtonDanger: true,
    title: t(
      'button.button-delete-confirm.title',
      'Sei sicuro di voler eliminare questo elemento?',
    ),
    tooltip: t('button.button-delete-confirm.tooltip', 'Elimina elemento'),
    okText: t('button.button-delete-confirm.ok', 'Elimina'),
    children: t('button.button-delete-confirm.content', 'Elimina'),
    ...props,
  } satisfies ConfirmButtonProps;

  return <ConfirmButton {...confirmProps} />;
}
